import { Table as TableAntd } from 'antd';
import styled from 'styled-components';

export const TableTmovShipper = styled(TableAntd)`
  .ant-table,
  .ant-table-thead > tr > th {
    color: #676a6c;
  }

  .ant-table table {
    table-layout: fixed !important;
  }

  .ant-table-thead > tr > th {
    font-weight: 700;
    font-size: 11px;
    background: #f5f5f6;
    border: 1px solid #e5e5e5;
  }

  .ant-table-tbody > tr > td {
    padding: 8px 8px;
    font-size: 12px;
    border: 1px solid #e5e5e5;
  }

  .ant-table-cell:last-child {
    text-align: center;
  }
`;
